<template>
  <div>
    <template v-for="(attribute, idx) in computedAttributes">
      <v-list-item :key="idx">
        <v-list-item-content>
          <v-list-item-title class="text-wrap">
            <Attribute
              :item="attribute.value"
              :translate="false"
            ></Attribute>
          </v-list-item-title>
          <v-list-item-subtitle v-text="`${attribute[`label_${$i18n.locale}`]} ${attribute.measure_unit}`" />
        </v-list-item-content>
      </v-list-item>
      <v-divider
        :key="`${idx}_divider`"
        v-if="idx + 1 < computedAttributes.length"
      />
    </template>
  </div>
</template>

<script>
import Attribute from '@/components/dashboard/Attribute';

export default {
  props: {
    attribute: {
      type: Object,
      required: true
    },
    currencyRatio: {
      type: Number,
      default: 0
    }
  },
  components: {
    Attribute
  },
  data: () => ({
    calculatedPrice: null
  }),
  computed: {
    computedAttributes() {
      if (this.attribute.value) {
        return [
          {
            ...this.attribute,
            measure_unit: '[PLN]',
          },
          {
            label_en: `${this.attribute.label_en}`,
            label_pl: `${this.attribute.label_pl}`,
            measure_unit: '[EUR]',
            name: 'cena_euro',
            translate: false,
            type: 'price',
            value: this.calculatedPrice
          }
        ];
      }
      return [
        {
          ...this.attribute,
          measure_unit: '',
        }
      ];
    }
  },
  methods: {
    getFixedValue(value, precision = 4) {
      if (typeof value === 'number') {
        return Number(value).toFixed(precision);
      }
      return 0.0;
    },
    getEuroValues(value) {
      return this.getFixedValue(
        Math.round((value / this.currencyRatio + Number.EPSILON) * 100000) /
          100000
      );
    },
    calculatePrice() {
      this.calculatedPrice = this.getEuroValues(this.attribute.value);
    }
  },
  mounted() {
    this.calculatePrice();
  }
};
</script>

<style lang="scss" scoped>
</style>